import mime from 'mime';

import { IconFileImage, IconFilePDF, IconFileWord } from '@xing-com/icons';

export const UPLOAD_ERROR_COPY_KEYS = {
  GENERIC: 'JOBS_INSTANT_APPLY_UPLOAD_GENERIC_ERROR',
  MAX_FILES_ALLOWED: 'JOBS_INSTANT_APPLY_UPLOAD_MAX_X_FILES_ALLOWED_ERROR',
  MIME_TYPE_NOT_SUPPORTED: 'JOBS_APPLY_UPLOAD_MIME_TYPE_NOT_SUPPORTED_ERROR',
  FILE_SIZE_TOO_LARGE: 'JOBS_APPLY_UPLOAD_FILE_SIZE_TOO_LARGE_ERROR',
  FILE_NAME_TOO_LONG: 'JOBS_APPLY_UPLOAD_FILE_NAME_TOO_LONG_ERROR',
  FILE_DUPLICATION: 'JOBS_APPLY_UPLOAD_FILE_DUPLICATION',
};

export const FILE_ICONS_BY_TYPE: Record<string, React.FC> = {
  'text/plain': IconFileWord,
  'application/msword': IconFileWord,
  'application/vnd.oasis.opendocument.text': IconFileWord,
  'application/rtf': IconFileWord,
  'application/pdf': IconFilePDF,
  'image/jpeg': IconFileImage,
  'image/png': IconFileImage,
};

export const DEFAULT_FILE_ICON = IconFileImage;

const FILE_EXTENSION_ALIASES: Record<string, string> = {
  jpeg: 'jpg',
};

const MIME_TYPE_ALIASES: Record<string, string> = {
  'image/jpg': 'image/jpeg',
};

export const normalizeMimeType = (mimeType: string): string =>
  MIME_TYPE_ALIASES[mimeType] ?? mimeType;

export const isSupportedMimeType = (
  mimeType: string,
  supportedTypes: string
): boolean =>
  supportedTypes
    .split(',')
    .map((type) => type.trim())
    .includes(normalizeMimeType(mimeType));

export const getSupportedFileTypes = (supportedTypes: string): string => {
  const extensions = supportedTypes
    .split(',')
    .map((type) => mime.getExtension(type))
    .filter((extension): extension is string => extension !== null)
    .map((extension) => FILE_EXTENSION_ALIASES[extension] ?? extension);

  return Array.from(new Set(extensions)).join(', ');
};

export const MAX_FILE_NAME_LENGTH = 150;
export const DEFAULT_MAX_FILESIZE_BYTES = 5242880; // 5MB
export const DEFAULT_ACCEPTED_MIME_TYPES =
  'text/plain,application/msword,application/pdf,image/jpeg,image/png,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/rtf,text/rtf';
